import styled from 'styled-components';

export default styled.div`
  font-family: var(--google-sora-cdn);
  font-weight: 800;
  font-size: 30px;
  line-height: 40px;
  color: var(--text-color);
  display: flex;
  flex-direction: column;
  justify-content: center;

  p {
    margin: 0;
    font-family: var(--google-sora-cdn);
    font-weight: 800;
    font-size: 30px;
    line-height: 40px;
    color: inherit;

    &:first-child {
      margin-bottom: 0;
    }
  }

  @media screen and (max-width: 480px) {
    font-size: 24px;
    line-height: 32px;

    p {
      font-size: 24px;
      line-height: 32px;
    }
  }
`;
